<template>
  <li ref="menuLink" class="text-sm">
    <UiLink
      v-if="menuItem.url"
      :to="menuItem.url"
      class="inline-flex"
      :class="
        isParent
          ? 'mb-6 -tracking-[0.1px] text-gray-lighten2 opacity-50'
          : 'title uppercase tracking-[.12em] text-white'
      "
    >
      {{ menuItem.name }}
    </UiLink>

    <slot></slot>
  </li>
</template>

<script setup lang="ts">
interface Props {
  menuItem?: any;
  isActive?: boolean;
  isParent?: boolean;
}

withDefaults(defineProps<Props>(), {
  menuItem: () => ({}),
  isActive: false,
  isParent: false,
});
</script>
